import React from 'react';
import HeroSection from '../components/HeroSection';
import ServiceCard from '../components/ServiceCard';
import './DomesticPage.css';

function DomesticPage() {
  return (
    <div className="domestic-page">
      <HeroSection
        backgroundImage="/images/hero_domestic.jpg"
        title="Professional Carpet Cleaning for Your Home"
        subtitle="Restore your carpets to their best with a deep, professional clean — safe for children, pets, and the whole family."
        ctaText="Get a Free Home Cleaning Quote"
        ctaLink="/contact"
      />

      {/* Value Propositions */}
      <section className="section">
        <div className="container">
          <div className="section-header">
            <h2>Every Room, Beautifully Cleaned</h2>
            <p>
              From high-traffic hallways to cosy bedrooms, we bring the same professional 
              equipment and expertise used in commercial settings directly to your home.
            </p>
          </div>
          <div className="grid grid--3">
            <ServiceCard
              icon="&#128715;"
              title="Living Rooms"
              description="Remove embedded dirt, pet hair, and everyday stains from your most-used room. Your carpet will look and feel like new."
            />
            <ServiceCard
              icon="&#128716;"
              title="Bedrooms"
              description="A deep clean that removes allergens and dust mites, creating a fresher, healthier sleeping environment."
            />
            <ServiceCard
              icon="&#128682;"
              title="Stairs &amp; Hallways"
              description="High-traffic areas that show wear first. We restore them to match the rest of your home."
            />
          </div>
        </div>
      </section>

      {/* Living Room Image + Text */}
      <section className="section section--soft">
        <div className="container">
          <div className="split">
            <div className="split__image">
              <img
                src="/images/domestic_living_room_result.jpg"
                alt="British family living room with freshly cleaned cream carpet"
              />
            </div>
            <div className="split__content">
              <h2>Your Home Deserves a Deep Clean</h2>
              <p>
                Regular vacuuming only removes surface dirt. Over time, grit, allergens, 
                and bacteria build up deep within the carpet fibres — dulling the colour 
                and affecting air quality.
              </p>
              <p>
                Our professional hot-water extraction goes deeper, removing what vacuum 
                cleaners leave behind. The difference is visible immediately — brighter 
                colours, softer texture, and a fresher-smelling home.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Staircase Image + Text */}
      <section className="section">
        <div className="container">
          <div className="split split--reverse">
            <div className="split__image">
              <img
                src="/images/domestic_staircase_hallway.jpg"
                alt="British family home hallway and staircase with freshly cleaned carpet"
              />
            </div>
            <div className="split__content">
              <h2>Every Room, Every Floor</h2>
              <p>
                Stairs and hallways are the hardest-working carpets in your home. They 
                show wear and discolouration faster than any other area.
              </p>
              <p>
                We give these high-traffic zones the attention they need, restoring them 
                to match the rest of your home. The transformation is remarkable — 
                and the results last.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Quick Turnaround Section */}
      <section className="section section--muted">
        <div className="container">
          <div className="section-header">
            <h2>Book Today, Cleaned Tomorrow</h2>
            <p>
              We know life is busy. That's why we make booking as easy as possible.
            </p>
          </div>
          <div className="feature-highlights">
            <div className="feature-highlight">
              <div className="feature-highlight__icon">&#128197;</div>
              <h3 className="feature-highlight__title">Flexible Scheduling</h3>
              <p className="feature-highlight__desc">
                Mornings, evenings, or weekends — we work around your family's 
                routine, not the other way around.
              </p>
            </div>
            <div className="feature-highlight">
              <div className="feature-highlight__icon">&#9889;</div>
              <h3 className="feature-highlight__title">Quick Turnaround</h3>
              <p className="feature-highlight__desc">
                We can often book you in within 24 hours. Need it sooner? 
                Call us — we'll do our best.
              </p>
            </div>
            <div className="feature-highlight">
              <div className="feature-highlight__icon">&#127807;</div>
              <h3 className="feature-highlight__title">Safe for the Family</h3>
              <p className="feature-highlight__desc">
                Eco-friendly, non-toxic products that are safe for children, pets, 
                and everyone in your home.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Strong CTA */}
      <section className="sales-cta">
        <div className="container">
          <h2>Ready for Carpets That Look Like New?</h2>
          <p>
            Call now for a free, no-obligation quote. We'll have your 
            home's carpets looking beautiful in no time.
          </p>
          <a href="tel:+447887394404" className="sales-cta__phone">
            07887 394404
          </a>
          <button
            className="btn btn--accent btn--lg"
            onClick={() => window.location.href = '/contact'}
          >
            Or Request a Quote Online
          </button>
          <p className="sales-cta__sub">
            Same-day response guaranteed. Evening and weekend appointments available.
          </p>
        </div>
      </section>
    </div>
  );
}

export default DomesticPage;
